import { useCallback } from 'react';
import { Platform } from 'react-native';

import { datadog } from '@sg/expo-datadog-client';

import { useMixpanel } from '@order/Telemetry';

import { getUserId } from '../getUserId';

export const useLogError = () => {
  const { track: mixpanelTrack } = useMixpanel();

  return useCallback(
    async (error: Error, info: Readonly<{ componentStack: string }>) => {
      const userId = await getUserId();
      const platform = Platform.OS;
      const { message, stack } = error;

      await datadog.reportError(error, {
        context: { componentStack: info.componentStack, userId, platform },
      });

      mixpanelTrack('app.error-boundary.crash', {
        error: message,
        stack,
        info,
      });
    },
    [mixpanelTrack],
  );
};
